import { useEffect, useState, type CSSProperties, type HTMLAttributes, type ImgHTMLAttributes, type ReactNode } from "react";
import { directWebMediaUrl, resolveAccountMediaUrl } from "../runtime/accountMedia";

export function useAccountMediaUrl(source: string | null | undefined, motion = false): string {
  const initial = !motion && /\.(gif|mp4|webm)(?:[?#]|$)|^data:(image\/gif|video\/)/i.test(source || '') ? '' : directWebMediaUrl(source);
  const [resolvedUrl, setResolvedUrl] = useState({source,motion,url:initial});
  const setUrl = (url:string) => setResolvedUrl({source,motion,url});
  useEffect(() => {
    let active = true; let temporary = '';
    setUrl(initial);
    void resolveAccountMediaUrl(source, motion).then((resolved) => { if (motion && resolved.startsWith('blob:') && resolved !== source) temporary = resolved; if (active) setUrl(resolved); else if (temporary) URL.revokeObjectURL(temporary); }).catch(() => { if (active) setUrl(''); });
    return () => { active = false; if (temporary) URL.revokeObjectURL(temporary); };
  }, [source, motion]);
  return resolvedUrl.source === source && resolvedUrl.motion === motion ? resolvedUrl.url : initial;
}

export function AccountMediaImage({ source, alt, ...props }: Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & { source?: string | undefined; alt: string }) {
  const url = useAccountMediaUrl(source);
  if (!url) return null;
  return <img {...props} src={url} alt={alt} />;
}

interface AccountMediaSurfaceProps extends HTMLAttributes<HTMLDivElement> {
  source?: (string) | undefined;
  overlay?: string;
  fallbackStyle?: CSSProperties;
  children?: ReactNode;
}

export function AccountMediaSurface({ source, overlay, fallbackStyle, style, children, ...props }: AccountMediaSurfaceProps) {
  const url = useAccountMediaUrl(source);
  const backgroundImage = url ? `${overlay ? `${overlay},` : ""}url(${JSON.stringify(url)})` : undefined;
  return <div {...props} data-media-state={url ? "ready" : source ? "unavailable" : "empty"} style={{ ...fallbackStyle, ...style, ...(backgroundImage ? { backgroundImage } : {}) }}>{children}</div>;
}
